import React, {useEffect, useState} from 'react';
import 'leaflet/dist/leaflet.css';

import {Box, Button, Input, Tooltip, Typography, useMediaQuery, useTheme} from "@mui/material";
import {tokens} from "../theme";
import Grid from "@mui/material/Unstable_Grid2";
import VisibilityIcon from '@mui/icons-material/Visibility';
import {createMRTColumnHelper, MaterialReactTable, useMaterialReactTable} from "material-react-table";
import {MRT_Localization_EL} from "material-react-table/locales/el";
import {deleteUser, retrieveUsers, userInfo, userUpdate} from "../api/user";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import {toast} from "react-toastify";
import CustomModal from "./CustomModal";
import Modal from "react-bootstrap/Modal";
import ManageRfid from "../components/ManageRfid";

const columnHelper = createMRTColumnHelper();

const AdminPanel = () => {

    const theme = useTheme();
    const smScreen = useMediaQuery(theme.breakpoints.up("sm"));
    const colors = tokens(theme.palette.mode);
    const [data, setData] = useState([]);
    const [reload, setReload] = useState(1);
    const [modalIsOpen, setIsOpen] = useState(false);
    const [rfids, setRFID] = useState();
    const [rfidUser, setRfidUser] = useState();
    const [searchTerm, setSearchTerm] = useState('');
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [userToDelete, setUserToDelete] = useState(null);
    const [confirmUsername, setConfirmUsername] = useState('');
    const [deleting, setDeleting] = useState(false);

    const openModal = (row, renderedCellValue) => {
        setRfidUser(row.original._id)
        setRFID(renderedCellValue)
        setIsOpen(true)
    }

    const closeModal = () => {
        setReload(reload + 1)
        setIsOpen(false);
    }

    const openDeleteModal = (user) => {
        setUserToDelete(user);
        setConfirmUsername('');
        setDeleteModalOpen(true);
    }

    const closeDeleteModal = () => {
        setDeleteModalOpen(false);
        setUserToDelete(null);
        setConfirmUsername('');
        setDeleting(false);
    }

    const handleDeleteUser = () => {
        if (!userToDelete || confirmUsername !== userToDelete.username) {
            return;
        }
        setDeleting(true);
        deleteUser(userToDelete._id)
            .then(() => {
                toast.success("Επιτυχής Διαγραφή Χρήστη");
                closeDeleteModal();
                setReload((prev) => prev + 1);
            })
            .catch((err) => {
                console.log(err);
                toast.error(
                    err?.response?.data?.error
                    ?? err?.response?.data?.message
                    ?? err?.message
                    ?? "Σφάλμα κατά τη διαγραφή"
                );
            })
            .finally(() => setDeleting(false));
    }

    const canConfirmDelete = userToDelete && confirmUsername === userToDelete.username;

    useEffect(() => {
        retrieveUsers()
            .then((res) => {
                setData(res.data)
            })
            .catch((err) => {
                console.log(err)
            })
    }, [reload]);

    const updateUser = (values) => {
        userUpdate(values._id, values)
            .then((_) => {
                toast.success("Επιτυχής Ενημέρωση")
            })
            .catch(err => {
                console.log(err)
                toast.error(err.response.data.message ?? "Σφαλμα");
            })
            .finally(() => setReload(reload + 1))
    }

    const columns = [
        columnHelper.accessor('_id', {header: 'ID', enableEditing: false}),

        columnHelper.accessor('username', {header: 'username'}),
        columnHelper.accessor('email', {header: 'email'}),
        columnHelper.accessor('rfids', {
            header: 'RFID List',
            id: 'rfid',
            enableEditing: false,
            Cell: ({renderedCellValue, row}) => (
                <VisibilityIcon onClick={() => openModal(row, renderedCellValue)} style={{cursor: 'pointer'}}/>
            ),
        }),
        columnHelper.accessor('role', {header: 'role',enableEditing: false}),
        columnHelper.accessor((row) => new Date(row.createdAt).toLocaleString('en-GB', {
            timeZone: 'Europe/Athens',
            hour12: false
        }), {
            header: 'createdAt',
            id: 'createdAt',
            enableEditing: false
        }),
        columnHelper.accessor((row) => new Date(row.updatedAt).toLocaleString('en-GB', {
            timeZone: 'Europe/Athens',
            hour12: false
        }), {
            header: 'updatedAt',
            id: 'updatedAt',
            enableEditing: false
        }),

    ];

    const CustomActions = () => {
        return (<></>);
    }


    const table = useMaterialReactTable({
        columns,
        data,
        enableRowActions: true,
        editDisplayMode: 'row',
        filterFns: {
            myCustomFilterFn: (row, id, filterValue) => {
                for (const key in row.original) {
                    if (Object.hasOwn(row.original, key)) {
                        const value = row.original[key];
                        if (Array.isArray(value)) {
                            if (value.includes(filterValue)) {
                                return true;
                            }
                        } else if (typeof value === 'string') {
                            if (value.includes(filterValue)) {
                                return true;
                            }
                        }
                    }
                }
                return false;
            },
        },
        globalFilterFn: 'myCustomFilterFn',
        renderRowActions: ({row}) => (
            <Box sx={{display: 'flex', gap: '1rem'}}>
                <Tooltip title={<span style={{fontSize: '14px'}}>Edit </span>}><EditIcon
                    style={{cursor: 'pointer'}} onClick={() => table.setEditingRow(row)}/></Tooltip>
                <Tooltip title={<span style={{fontSize: '14px'}}>Διαγραφή</span>}>
                    <DeleteIcon
                        style={{cursor: 'pointer', color: '#b21a1b'}}
                        onClick={() => openDeleteModal(row.original)}
                    />
                </Tooltip>
            </Box>
        ),
        onEditingRowSave: ({table, values, row}) => {
            updateUser(values)
            table.setEditingRow(null);
        },
        positionActionsColumn: 'last',
        columnFilterDisplayMode: 'popover',
        paginationDisplayMode: 'pages',
        enableRowSelection: true,
        enableEditing: true,
        positionToolbarAlertBanner: 'bottom',
        autoResetPageIndex: false,
        autoResetExpanded: false,
        renderTopToolbarCustomActions: ({table}) => (
            <CustomActions/>
        ),
        localization: {...MRT_Localization_EL},

    });

    const getUser = (userId) => {
        userInfo(userId)
            .then((res) => {
                console.log(res)
            })
    };

    return (
        <div style={{height: '92vh'}}>
            <Typography
                variant="h4"
                fontWeight="600"
                color={colors.grey[100]}
                style={{marginLeft: '20px'}}
            >
                Admin Panel
            </Typography>
            <Box m="20px">
                <Box
                    display={smScreen ? "flex" : "block"}
                    flexDirection={smScreen ? "row" : "column"}
                    justifyContent={smScreen ? "space-between" : "start"}
                    alignItems={smScreen ? "center" : "start"}
                    m="10px 0"
                >
                </Box>

                <Grid container rowSpacing={1} columnSpacing={{xs: 1, sm: 2, md: 3}}>
                    <Grid
                        xs={12}
                        sm={12}
                        md={8}
                        lg={12}
                        container
                        rowSpacing={1}
                        columnSpacing={{xs: 1, sm: 2, md: 3}}
                    >
                        <Grid xs={12}>
                            <Box backgroundColor={colors.primary[400]} style={{borderRadius: '10px'}}>

                                <Box
                                    mt="25px"
                                    p="0 30px"
                                    display="flex"
                                    justifyContent="space-between"
                                    alignItems="center"
                                >
                                    <Box style={{padding: '10px', width: '100%'}}>
                                        <Typography
                                            variant="h5"
                                            fontWeight="600"
                                            color={colors.grey[100]}
                                            style={{padding: '10px'}}
                                        >
                                            Ενεργοί Χρήστες
                                        </Typography>
                                        <MaterialReactTable table={table}/>
                                    </Box>
                                </Box>
                            </Box>
                            <Modal show={modalIsOpen}
                                   onHide={closeModal}
                                   size="lg"
                                   aria-labelledby="contained-modal-title-vcenter"
                                   centered>
                                <CustomModal title='Διαχείριση RFID' closeModal={closeModal}>
                                    <ManageRfid userId={rfidUser} rfids={rfids}/>
                                </CustomModal>
                            </Modal>
                            <Modal show={deleteModalOpen}
                                   onHide={closeDeleteModal}
                                   size="sm"
                                   aria-labelledby="contained-modal-title-vcenter"
                                   centered>
                                <CustomModal title='Διαγραφή Χρήστη' closeModal={closeDeleteModal}>
                                    {userToDelete && (
                                        <div style={{padding: '10px 16px 20px'}}>
                                            <p style={{marginBottom: '10px', fontSize: '14px'}}>
                                                Είστε σίγουροι ότι θέλετε να διαγράψετε τον:
                                            </p>
                                            <p style={{marginBottom: '6px', fontSize: '14px'}}>
                                                <strong>Χρήστη:</strong> {userToDelete.username}
                                            </p>
                                            <p style={{marginBottom: '6px', fontSize: '14px'}}>
                                                <strong>Email:</strong> {userToDelete.email}
                                            </p>
                                            {userToDelete.rfids && userToDelete.rfids.length > 0 && (
                                                <p style={{marginBottom: '6px', fontSize: '14px'}}>
                                                    <strong>RFID:</strong> [{userToDelete.rfids.join(', ')}]
                                                </p>
                                            )}
                                            <p style={{marginTop: '12px', marginBottom: '12px', fontSize: '13px', color: '#d83938', fontWeight: '600'}}>
                                                Η διαγραφή του χρήστη είναι τελική!
                                            </p>
                                            <p style={{marginBottom: '8px', fontSize: '13px'}}>
                                                Γράψτε το username για επιβεβαίωση:
                                            </p>
                                            <div className="input-block" style={{marginBottom: '8px'}}>
                                                <Input
                                                    variant="outlined"
                                                    disableUnderline={true}
                                                    id="confirm-username"
                                                    value={confirmUsername}
                                                    placeholder="Username"
                                                    onChange={(e) => setConfirmUsername(e.target.value)}
                                                    type="text"
                                                    autoComplete="off"
                                                    fullWidth
                                                />
                                            </div>
                                            <div style={{display: 'flex', justifyContent: 'flex-end', gap: '12px', marginTop: '20px'}}>
                                                <Button
                                                    style={{
                                                        height: '30px',
                                                        border: '1px solid gray',
                                                        textTransform: 'none',
                                                        minWidth: '110px',
                                                    }}
                                                    onClick={closeDeleteModal}
                                                    disabled={deleting}
                                                >
                                                    Ακύρωση
                                                </Button>
                                                <Button
                                                    style={{
                                                        height: '30px',
                                                        border: '1px solid gray',
                                                        textTransform: 'none',
                                                        minWidth: '110px',
                                                        color: canConfirmDelete ? '#d83938' : undefined,
                                                        opacity: canConfirmDelete && !deleting ? 1 : 0.5,
                                                    }}
                                                    disabled={!canConfirmDelete || deleting}
                                                    onClick={handleDeleteUser}
                                                >
                                                    {deleting ? 'Διαγραφή...' : 'Διαγραφή'}
                                                </Button>
                                            </div>
                                        </div>
                                    )}
                                </CustomModal>
                            </Modal>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </div>
    );
};

export default AdminPanel;
